import { render, staticRenderFns } from "./GroupsTree.vue?vue&type=template&id=2ea6fb23&scoped=true&"
import script from "./GroupsTree.vue?vue&type=script&lang=js&"
export * from "./GroupsTree.vue?vue&type=script&lang=js&"
import style0 from "./GroupsTree.vue?vue&type=style&index=0&id=2ea6fb23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea6fb23",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ea6fb23')) {
      api.createRecord('2ea6fb23', component.options)
    } else {
      api.reload('2ea6fb23', component.options)
    }
    module.hot.accept("./GroupsTree.vue?vue&type=template&id=2ea6fb23&scoped=true&", function () {
      api.rerender('2ea6fb23', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/management/vistas/components/GroupsTree.vue"
export default component.exports